<div class="sm-relative">
  <div class="sm-absolute sm-inset-0 sm-flex sm-items-center" aria-hidden="true">
    <div class="sm-w-full sm-border-t-2 sm-border-dashed sm-border-grey-4"></div>
  </div>
  <div class="sm-relative sm-flex sm-justify-center">
    <span class="sm-bg-white sm-px-2 sm-text-secondary-text" i18n>Page break</span>
  </div>
</div>
